import { Injectable } from '@angular/core';

import { map } from 'rxjs';

import type {
  AnyIntelligenceSettings,
  IntelligenceFeatureSettings,
  IntelligenceSettingsResponse,
  DisqualifyReasonOption,
} from '@core/intelligence-types';
import { injectTellentIntelligenceHttp } from '@core/tellent-http-legacy';

@Injectable({ providedIn: 'root' })
export class IntelligenceSettingsHttp {
  private httpApi = injectTellentIntelligenceHttp();

  public fetch() {
    return this.httpApi
      .get<IntelligenceSettingsResponse>('/settings', null, null)
      .pipe(map((response): IntelligenceSettingsResponse => response));
  }

  public toggleFeature(
    state: Partial<Record<AnyIntelligenceSettings['field'], boolean>> & { enabled?: boolean },
  ) {
    return this.httpApi
      .patch<IntelligenceSettingsResponse>('/settings', null, state)
      .pipe(map((response): IntelligenceSettingsResponse => response));
  }

  public updateFeatureSettings(state: Partial<IntelligenceFeatureSettings>) {
    return this.httpApi
      .patch<IntelligenceSettingsResponse>('/settings', null, state)
      .pipe(map((response): IntelligenceSettingsResponse => response));
  }

  public fetchDisqualifyReasons(appGuid: string) {
    return this.httpApi
      .get(`/api/app/${appGuid}/recruitment/disqualify-reasons`, null, {
        skipCompany: true,
      })
      .pipe(map((response): DisqualifyReasonOption[] => response.data));
  }
}
